{
  "HELP_CENTER": {
    "TITLE": "Centre d'aide",
    "NEW_PAGE": {
      "DESCRIPTION": "Créez des portails de centre d'aide en libre-service pour vos clients. Aidez-les à trouver rapidement des réponses, sans attendre. Simplifiez les demandes, améliorez l'efficacité des agents et optimisez le support client.",
      "CREATE_PORTAL_BUTTON": "Créer un portail"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Sans titre"
    },
    "HEADER": {
      "FILTER": "Filtrer par",
      "SORT": "Trier par",
      "LOCALE": "Langue",
      "SETTINGS_BUTTON": "Paramètres",
      "NEW_BUTTON": "Nouvel article",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publié",
        "DRAFT": "Draft",
        "ARCHIVED": "Archivé"
      },
      "TITLES": {
        "ALL_ARTICLES": "Tous les articles",
        "MINE": "Mes articles",
        "DRAFT": "Articles Draft",
        "ARCHIVED": "Articles archivés"
      },
      "LOCALE_SELECT": {
        "TITLE": "Choisir un paramètre régional",
        "PLACEHOLDER": "Choisir un paramètre régional",
        "NO_RESULT": "Paramètre régional introuvable",
        "SEARCH_PLACEHOLDER": "Chercher un paramètre régional"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Tous les articles",
      "PUBLISH_BUTTON": "Publier",
      "MOVE_TO_ARCHIVE_BUTTON": "Déplacer dans les archives",
      "PREVIEW": "Aperçu",
      "ADD_TRANSLATION": "Ajouter la traduction",
      "OPEN_SIDEBAR": "Ouvrir le panneau latéral",
      "CLOSE_SIDEBAR": "Fermer le panneau latéral",
      "SAVING": "Enregistrement en cours...",
      "SAVED": "Enregistré"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Téléverser une image",
        "UPLOADING": "Téléversement...",
        "SUCCESS": "Image téléchargée avec succès",
        "ERROR": "Erreur lors du téléchargement de l'image",
        "UN_AUTHORIZED_ERROR": "Vous n'êtes pas autorisé à téléverser des images",
        "ERROR_FILE_SIZE": "La taille de l'image doit être inférieure à {size}Mo",
        "ERROR_FILE_FORMAT": "Le format d'image doit être jpg, jpeg ou png",
        "ERROR_FILE_DIMENSIONS": "Les dimensions de l'image doivent être inférieures à 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Insérer une ancre",
        "TITLE": "Insérer une ancre",
        "SUBMIT": "Insérer",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Paramètres de l'article",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Catégorie",
          "TITLE": "Sélectionner une catégorie",
          "PLACEHOLDER": "Sélectionner une catégorie",
          "NO_RESULT": "Aucune catégorie trouvée",
          "SEARCH_PLACEHOLDER": "Rechercher dans la catégorie"
        },
        "AUTHOR": {
          "LABEL": "Auteur",
          "TITLE": "Sélectionner l'auteur",
          "PLACEHOLDER": "Sélectionner l'auteur",
          "NO_RESULT": "Aucun auteur trouvé",
          "SEARCH_PLACEHOLDER": "Rechercher un auteur"
        },
        "META_TITLE": {
          "LABEL": "Méta titre",
          "PLACEHOLDER": "Ajouter un titre méta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Méta description",
          "PLACEHOLDER": "Ajouter votre méta description pour de meilleurs résultats SEO..."
        },
        "META_TAGS": {
          "LABEL": "Balises méta",
          "PLACEHOLDER": "Ajouter des balises méta séparées par des virgules..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archiver l'article",
        "DELETE": "Supprimer l'article"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Non catégorisé",
      "SEARCH_RESULTS": "Résultats de la recherche pour {query}",
      "EMPTY_TEXT": "Rechercher des articles à insérer dans les réponses.",
      "SEARCH_LOADER": "Recherche en cours...",
      "INSERT_ARTICLE": "Insérer",
      "NO_RESULT": "Aucun article trouvé",
      "COPY_LINK": "Copier le lien de l'article dans le presse-papier",
      "OPEN_LINK": "Ouvrir un article dans un nouvel onglet",
      "PREVIEW_LINK": "Aperçu de l'article"
    },
    "PORTAL": {
      "HEADER": "Portails",
      "DEFAULT": "Par défaut",
      "NEW_BUTTON": "Nouveau portail",
      "ACTIVE_BADGE": "actif",
      "CHOOSE_LOCALE_LABEL": "Choisir une langue",
      "LOADING_MESSAGE": "Chargement des portails...",
      "ARTICLES_LABEL": "articles",
      "NO_PORTALS_MESSAGE": "Il n'y a aucun portail disponible",
      "ADD_NEW_LOCALE": "Ajouter une nouvelle langue",
      "POPOVER": {
        "TITLE": "Portails",
        "PORTAL_SETTINGS": "Paramètres du portail",
        "SUBTITLE": "Vous avez plusieurs portails et pouvez avoir différents paramètres régionaux pour chaque portail.",
        "CANCEL_BUTTON_LABEL": "Annuler",
        "CHOOSE_LOCALE_BUTTON": "Choisir une langue"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "articles",
            "ADD": "Ajouter une langue",
            "VISIT": "Visiter le site",
            "SETTINGS": "Paramètres",
            "DELETE": "Supprimer"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configurations du portail",
            "ITEMS": {
              "NAME": "Nom",
              "DOMAIN": "Domaine personnalisé",
              "SLUG": "Slug",
              "TITLE": "Titre du portail",
              "THEME": "Couleur du thème",
              "SUB_TEXT": "Sous texte du portail"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Langues disponibles",
            "TABLE": {
              "NAME": "Nom de la langue",
              "CODE": "Code de la langue",
              "ARTICLE_COUNT": "Nb d'articles",
              "CATEGORIES": "Nb de catégories",
              "SWAP": "Permuter",
              "DELETE": "Supprimer",
              "DEFAULT_LOCALE": "Par défaut"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Supprimer le portail",
          "MESSAGE": "Êtes-vous sûr de vouloir supprimer ce portail",
          "YES": "Oui, supprimer le portail",
          "NO": "Non, conserver le portail",
          "API": {
            "DELETE_SUCCESS": "Le portail a été supprimé",
            "DELETE_ERROR": "Erreur durant la suppression du portail"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Modifier le portail",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informations de base"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personnalisation du portail"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Catégories"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Langues"
          }
        },
        "CATEGORIES": {
          "TITLE": "Catégories dans",
          "NEW_CATEGORY": "Nouvelle catégorie",
          "TABLE": {
            "NAME": "Nom",
            "DESCRIPTION": "Description",
            "LOCALE": "Langue",
            "ARTICLE_COUNT": "Nb d'articles",
            "ACTION_BUTTON": {
              "EDIT": "Modifier la catégorie",
              "DELETE": "Supprimer la catégorie"
            },
            "EMPTY_TEXT": "Aucune catégorie trouvée"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Mettre à jour les paramètres de base"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informations sur le centre d'aide",
            "BODY": "Informations de base sur le portail"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personnalisation du centre d'aide",
            "BODY": "Personnalisez le portail"
          },
          "FINISH": {
            "TITLE": "Et voilà ! 🎉",
            "BODY": "Tout est prêt !"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Précédent",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Créer un portail",
            "TITLE": "Informations sur le centre d'aide",
            "CREATE_BASIC_SETTING_BUTTON": "Créer des paramètres de base du portail"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personnalisation du portail",
            "TITLE": "Personnalisation du centre d'aide",
            "UPDATE_PORTAL_BUTTON": "Mettre à jour les paramètres du portail"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Vous êtes prêt !",
            "MESSAGE": "Vous pouvez maintenant voir ce portail créé sur votre page de portails.",
            "FINISH": "Aller à la page de tous les portails"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Télécharger le logo",
          "HELP_TEXT": "Ce logo sera affiché sur l'en-tête du portail.",
          "IMAGE_UPLOAD_SUCCESS": "Logo téléchargé",
          "IMAGE_UPLOAD_ERROR": "Logo effacé",
          "IMAGE_DELETE_ERROR": "Erreur lors de la suppression du logo"
        },
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom du portail",
          "HELP_TEXT": "Le nom sera utilisé dans le portail public en interne.",
          "ERROR": "Le nom est requis"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Identifiant du portail pour les URL",
          "ERROR": "Le Slug est requis"
        },
        "DOMAIN": {
          "LABEL": "Domaine personnalisé",
          "PLACEHOLDER": "Portail de domaine personnalisé",
          "HELP_TEXT": "À ajouter uniquement si vous souhaitez utiliser un domaine personnalisé pour vos portails. Ex. : {exampleURL}",
          "ERROR": "Entrez une URL de domaine valide"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lien vers la page d'accueil",
          "PLACEHOLDER": "Lien vers la page d'accueil du portail",
          "HELP_TEXT": "Le lien utilisé pour revenir du portail vers la page d'accueil. Ex. : {exampleURL}",
          "ERROR": "Entrez une URL valide de la page d'accueil"
        },
        "THEME_COLOR": {
          "LABEL": "Couleur du thème du portail",
          "HELP_TEXT": "Cette couleur sera affichée comme la couleur du thème pour le portail."
        },
        "PAGE_TITLE": {
          "LABEL": "Titre de la page",
          "PLACEHOLDER": "Titre de la page portail",
          "HELP_TEXT": "Le titre de la page sera utilisé dans le portail public.",
          "ERROR": "Le titre de la page est requis"
        },
        "HEADER_TEXT": {
          "LABEL": "Texte de l'en-tête",
          "PLACEHOLDER": "Texte de l'en-tête du portail",
          "HELP_TEXT": "Le texte de l'en-tête du portail sera utilisé dans le portail public.",
          "ERROR": "Le texte de l'en-tête du portail est obligatoire"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Le portail a été créé avec succès.",
          "ERROR_MESSAGE_FOR_BASIC": "Impossible de créer le portail. Essayez à nouveau.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Le portail a été mis à jour.",
          "ERROR_MESSAGE_FOR_UPDATE": "Impossible de mettre à jour le portail. Essayez à nouveau."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Ajouter une nouvelle langue",
        "SUB_TITLE": "Ceci ajoute une nouvelle langue à votre liste de traductions disponibles.",
        "PORTAL": "Portail",
        "LOCALE": {
          "LABEL": "Langue",
          "PLACEHOLDER": "Choisir une langue",
          "ERROR": "La langue est requise"
        },
        "BUTTONS": {
          "CREATE": "Créer une langue",
          "CANCEL": "Annuler"
        },
        "API": {
          "SUCCESS_MESSAGE": "Langue ajoutée avec succès",
          "ERROR_MESSAGE": "Impossible d'ajouter la langue. Veuillez réessayer."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "La locale par défaut a été mise à jour",
          "ERROR_MESSAGE": "Impossible de mettre à jour la langue par défaut. Veuillez réessayer."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "La langue a été supprimée du portail avec succès",
          "ERROR_MESSAGE": "Impossible de supprimer la langue du portail. Réessayez."
        }
      }
    },
    "TABLE": {
      "404": "Aucun article ne correspond à votre recherche 🔍",
      "LOADING_MESSAGE": "Chargement des articles...",
      "NO_ARTICLES": "Il n'y a aucun article disponible",
      "HEADERS": {
        "TITLE": "Titre",
        "CATEGORY": "Catégorie",
        "READ_COUNT": "Vues",
        "STATUS": "État",
        "LAST_EDITED": "Dernière modification"
      },
      "COLUMNS": {
        "BY": "par",
        "AUTHOR_NOT_AVAILABLE": "L'auteur n'est pas disponible"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Chargement de l'article...",
      "TITLE_PLACEHOLDER": "Le titre de l'article va ici",
      "CONTENT_PLACEHOLDER": "Écrivez votre article ici",
      "API": {
        "ERROR": "Erreur lors de la sauvegarde de l'article"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Erreur lors de la publication de l'article",
        "SUCCESS": "L'article a été publié"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Erreur lors de l'archivage de l'article",
        "SUCCESS": "L'article a été archivé"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Erreur lors de la mise en Draft de l'article",
        "SUCCESS": "L'article a été mis en Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirmer la suppression",
          "MESSAGE": "Êtes-vous sûr de vouloir supprimer l'article ?",
          "YES": "Oui, supprimer",
          "NO": "Non, conservez-le"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "L'article a été supprimé",
        "ERROR_MESSAGE": "Erreur lors de la suppression de l'article"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Veuillez ajouter le titre et le contenu de l'article avant de pouvoir mettre à jour les paramètres"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Recherche d'articles"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Créer une catégorie",
        "SUB_TITLE": "La catégorie sera utilisée dans le portail public pour classer les articles.",
        "PORTAL": "Portail",
        "LOCALE": "Langue",
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom de la catégorie",
          "HELP_TEXT": "Le nom de la catégorie sera utilisé dans le portail public pour classer les articles.",
          "ERROR": "Le nom est requis"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de catégorie pour les URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Le Slug est requis"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Donner une courte description de la catégorie.",
          "ERROR": "La description est requise"
        },
        "BUTTONS": {
          "CREATE": "Créer une catégorie",
          "CANCEL": "Annuler"
        },
        "API": {
          "SUCCESS_MESSAGE": "Catégorie créée avec succès",
          "ERROR_MESSAGE": "Impossible de créer une catégorie"
        }
      },
      "EDIT": {
        "TITLE": "Modifier une catégorie",
        "SUB_TITLE": "Modifier une catégorie mettra à jour la catégorie dans le portail public visité.",
        "PORTAL": "Portail",
        "LOCALE": "Langue",
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom de la catégorie",
          "HELP_TEXT": "Le nom de la catégorie sera utilisé dans le portail public pour classer les articles.",
          "ERROR": "Le nom est requis"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de catégorie pour les URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Le Slug est requis"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Donner une courte description de la catégorie.",
          "ERROR": "La description est requise"
        },
        "BUTTONS": {
          "CREATE": "Mettre à jour la catégorie",
          "CANCEL": "Annuler"
        },
        "API": {
          "SUCCESS_MESSAGE": "Catégorie mise à jour correctement",
          "ERROR_MESSAGE": "Impossible de mettre à jour cette catégorie"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Catégorie supprimée avec succès",
          "ERROR_MESSAGE": "Impossible de supprimer la catégorie"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Rechercher des articles",
      "PLACEHOLDER": "Rechercher des articles",
      "NO_RESULT": "Aucun article trouvé",
      "SEARCHING": "Recherche en cours...",
      "SEARCH_BUTTON": "Rechercher",
      "INSERT_ARTICLE": "Insérer un lien",
      "IFRAME_ERROR": "L'URL est vide ou non valide. Impossible d'afficher le contenu.",
      "OPEN_ARTICLE_SEARCH": "Insérer un article depuis le centre d'aide",
      "SUCCESS_ARTICLE_INSERTED": "Article inséré",
      "PREVIEW_LINK": "Aperçu de l'article",
      "CANCEL": "Fermer",
      "BACK": "Précédent",
      "BACK_RESULTS": "Retour aux résultats"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centre d'aide",
      "DESCRIPTION": "Créez des portails en libre-service conviviaux. Aidez vos utilisateurs à accéder aux articles et à obtenir de l'aide 24h/24, 7j/7. Mettez à niveau votre abonnement pour activer cette fonctionnalité.",
      "SELF_HOSTED_DESCRIPTION": "Créez des portails en libre-service conviviaux. Aidez vos utilisateurs à accéder aux articles et à obtenir de l'assistance 24/7. Veuillez contacter votre administrateur pour activer cette fonctionnalité.",
      "BUTTON": {
        "LEARN_MORE": "En savoir plus",
        "UPGRADE": "Mise à niveau"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Portails multiples",
          "DESCRIPTION": "Créez plusieurs portails de centre d'aide pour différents produits en utilisant le même compte."
        },
        "LOCALES": {
          "TITLE": "Prise en charge complète des langues",
          "DESCRIPTION": "Affichez le portail dans votre langue. Nous prenons en charge toutes les langues et autorisons les traductions pour chaque article."
        },
        "SEO": {
          "TITLE": "Design optimisé pour le SEO",
          "DESCRIPTION": "Personnalisez vos balises méta pour améliorer votre visibilité sur les moteurs de recherche grâce à nos pages optimisées pour le SEO."
        },
        "API": {
          "TITLE": "Support complet de l'API",
          "DESCRIPTION": "Utilisez le portail comme un CMS sans tête avec des frameworks front-end tiers en utilisant nos API."
        }
      }
    },
    "LOADING": "Chargement...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} vue | {count} vues",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publier",
            "DRAFT": "Draft",
            "ARCHIVE": "Archiver",
            "DELETE": "Supprimer"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publié",
            "ARCHIVED": "Archivé"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Non catégorisé"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Tous les articles",
          "MINE": "Les miens",
          "DRAFT": "Draft",
          "PUBLISHED": "Publié",
          "ARCHIVED": "Archivé"
        },
        "CATEGORY": {
          "ALL": "Toutes les catégories"
        },
        "LOCALE": {
          "ALL": "Toutes les langues"
        },
        "NEW_ARTICLE": "Nouvel article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Rédiger un article",
          "SUBTITLE": "Rédigez un article riche, c'est parti !",
          "BUTTON_LABEL": "Nouvel article"
        },
        "MINE": {
          "TITLE": "Vous n'avez encore rédigé aucun article ici",
          "SUBTITLE": "Tous les articles que vous avez rédigés apparaissent ici pour un accès rapide."
        },
        "DRAFT": {
          "TITLE": "Il n'y a aucun article en Draft",
          "SUBTITLE": "Les articles Draft apparaîtront ici"
        },
        "PUBLISHED": {
          "TITLE": "Il n'y a aucun article publié",
          "SUBTITLE": "Les articles publiés apparaîtront ici"
        },
        "ARCHIVED": {
          "TITLE": "Il n'y a aucun article dans les archives",
          "SUBTITLE": "Les articles archivés n'apparaissent pas sur le portail, vous pouvez les utiliser pour marquer des pages obsolètes"
        },
        "CATEGORY": {
          "TITLE": "Il n'y a aucun article dans cette catégorie",
          "SUBTITLE": "Les articles de cette catégorie apparaîtront ici"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nouvelle catégorie",
        "EDIT_CATEGORY": "Modifier la catégorie",
        "CATEGORIES_COUNT": "{n} catégorie | {n} catégories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Catégories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Aucune catégorie trouvée",
        "SUBTITLE": "Les catégories apparaîtront ici. Vous pouvez ajouter une catégorie en cliquant sur le bouton « Nouvelle catégorie »."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "EXPAND": "Afficher les sous-catégories",
        "COLLAPSE": "Masquer les sous-catégories",
        "MENU": {
          "NEW_ARTICLE": "Nouvel article",
          "ADD_SUBCATEGORY": "Ajouter une sous-catégorie",
          "EDIT": "Modifier",
          "DELETE": "Supprimer"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Catégorie créée avec succès",
            "ERROR_MESSAGE": "Impossible de créer une catégorie"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Catégorie mise à jour correctement",
            "ERROR_MESSAGE": "Impossible de mettre à jour cette catégorie"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Catégorie supprimée avec succès",
            "ERROR_MESSAGE": "Impossible de supprimer la catégorie"
          },
          "CONFIRM": {
            "TITLE": "Supprimer la catégorie",
            "DESCRIPTION": "Êtes-vous sûr de vouloir supprimer cette catégorie ? Ses articles deviendront non catégorisés.",
            "DESCRIPTION_WITH_CHILDREN": "Êtes-vous sûr de vouloir supprimer cette catégorie ? Ses articles deviendront non catégorisés et sa {count} sous-catégorie sera déplacée au premier niveau. | Êtes-vous sûr de vouloir supprimer cette catégorie ? Ses articles deviendront non catégorisés et ses {count} sous-catégories seront déplacées au premier niveau.",
            "CONFIRM": "Supprimer"
          }
        },
        "HEADER": {
          "CREATE": "Créer une catégorie",
          "EDIT": "Modifier la catégorie",
          "DESCRIPTION": "Modifier une catégorie mettra à jour la catégorie dans le portail public visité.",
          "PORTAL": "Portail",
          "LOCALE": "Langue"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nom",
            "PLACEHOLDER": "Nom de la catégorie",
            "ERROR": "Le nom est requis"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug de catégorie pour les URL",
            "ERROR": "Le Slug est requis",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Description",
            "PLACEHOLDER": "Donner une courte description de la catégorie.",
            "ERROR": "La description est requise"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Catégorie parente",
            "PLACEHOLDER": "Sélectionner une catégorie parente",
            "NONE": "Aucune (premier niveau)"
          }
        },
        "BUTTONS": {
          "CREATE": "Créer",
          "EDIT": "Mettre à jour",
          "CANCEL": "Annuler"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Aucune langue disponible | {n} langue | {n} langues",
      "NEW_LOCALE_BUTTON_TEXT": "Nouvelle langue",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} catégorie | {count} catégories",
        "DEFAULT": "Par défaut",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Définir par défaut",
          "DELETE": "Supprimer"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Ajouter une nouvelle langue",
        "DESCRIPTION": "Sélectionnez la langue dans laquelle cet article sera rédigé. Elle sera ajoutée à votre liste de traductions et vous pourrez en ajouter d'autres plus tard.",
        "COMBOBOX": {
          "PLACEHOLDER": "Choisir un paramètre régional..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Langue ajoutée avec succès",
          "ERROR_MESSAGE": "Impossible d'ajouter la langue. Veuillez réessayer."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Enregistrement en cours...",
          "SAVED": "Enregistré"
        },
        "PREVIEW": "Aperçu",
        "PUBLISH": "Publier",
        "DRAFT": "Draft",
        "ARCHIVE": "Archiver",
        "BACK_TO_ARTICLES": "Retour aux articles"
      },
      "DRAFT": {
        "PENDING_LABEL": "Modifications non publiées",
        "PROMOTE": "Publier les modifications",
        "DISCARD": "Annuler les modifications",
        "PROMOTE_SUCCESS": "Modifications Draft publiées dans l'article en ligne",
        "PROMOTE_ERROR": "Impossible de publier les modifications Draft",
        "DISCARD_SUCCESS": "Modifications Draft annulées",
        "DISCARD_ERROR": "Impossible d'annuler les modifications Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historique des versions",
        "TITLE": "Historique des versions",
        "BACK": "Retour à l'article",
        "LOADING": "Chargement des versions...",
        "EMPTY": "Aucune version pour le moment. Les modifications apportées à cet article s'afficheront ici.",
        "EMPTY_CONTENT": "Cette version n'a pas de contenu.",
        "CURRENT_BADGE": "Actuelle",
        "RESTORED_BADGE": "Restaurée",
        "AUTOMATED_USER": "Mise à jour automatique",
        "RESTORE": "Restaurer cette version",
        "RESTORE_DIALOG": {
          "TITLE": "Restaurer cette version ?",
          "DESCRIPTION": "L'article reviendra au texte de cette version. Rien n'est perdu — le texte actuel reste dans l'historique, et un article publié continue d'afficher la version en ligne jusqu'à ce que vous publiiez la modification.",
          "CONFIRM": "Restaurer"
        },
        "RESTORE_SUCCESS": "Version restaurée",
        "RESTORE_ERROR": "Impossible de restaurer cette version",
        "FETCH_ERROR": "Impossible de charger l'historique des versions"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Plus de propriétés",
        "TRANSLATE": "Traduire",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Non catégorisé",
        "EDITOR_PLACEHOLDER": "Écrivez quelque chose...",
        "HTML_EMBED": {
          "TITLE": "Insérer du HTML personnalisé",
          "DESCRIPTION": "Collez du HTML brut tel qu'un iframe, un embed ou un extrait de widget. Il sera affiché tel quel dans l'article publié.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Insérer"
        },
        "PRIMARY_CATEGORY": "Catégorie principale"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Propriétés de l'article",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Méta description",
        "META_DESCRIPTION_PLACEHOLDER": "Ajouter une méta description",
        "META_TITLE": "Méta titre",
        "META_TITLE_PLACEHOLDER": "Ajouter un méta titre",
        "META_TAGS": "Balises méta",
        "META_TAGS_PLACEHOLDER": "Ajouter des balises méta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Variantes linguistiques",
        "LANGUAGE_MUTATIONS_EMPTY": "Aucun article lié pour le moment",
        "ADD_MUTATION": "Ajouter",
        "REMOVE_MUTATION": "Supprimer"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Lier des variantes linguistiques",
        "SEARCH_PLACEHOLDER": "Rechercher des articles par titre",
        "EMPTY": "Aucun article correspondant",
        "CANCEL": "Annuler",
        "ADD_SELECTED": "Ajouter la sélection",
        "SUCCESS": "Variantes mises à jour",
        "ERROR": "Échec de la mise à jour des variantes"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Traduire l'article",
        "DESCRIPTION": "Sélectionnez les langues dans lesquelles vous souhaitez traduire cet article. Les langues déjà traduites seront retraduites dans un Draft pour révision.",
        "EMPTY": "Aucune autre langue n'est disponible.",
        "CONNECTED_BADGE": "Traduit",
        "CANCEL": "Annuler",
        "TRANSLATE": "Traduire",
        "SUCCESS": "La traduction démarrera sous peu. Les articles traduits apparaîtront bientôt en tant que variantes linguistiques.",
        "ERROR": "Échec du démarrage de la traduction"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Erreur lors de la sauvegarde de l'article"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nouveau portail",
      "PORTALS": "Portails",
      "CREATE_PORTAL": "Créer et gérer plusieurs portails",
      "ARTICLES": "articles",
      "DOMAIN": "domaine",
      "PORTAL_NAME": "Nom du portail"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Créer un nouveau portail",
      "DESCRIPTION": "Donnez un nom à votre portail et créez un slug d'URL convivial. Vous pourrez modifier les deux ultérieurement dans les paramètres.",
      "CONFIRM_BUTTON_LABEL": "Créer",
      "NAME": {
        "LABEL": "Nom",
        "PLACEHOLDER": "Guide utilisateur",
        "MESSAGE": "Choisissez un nom pour votre portail.",
        "ERROR": "Le nom est requis"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Le Slug est requis",
        "FORMAT_ERROR": "Utilisez uniquement des lettres, des chiffres et des tirets, par exemple : user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Impossible de télécharger l'image ! Réessayez",
          "IMAGE_UPLOAD_SUCCESS": "Image ajoutée avec succès. Veuillez cliquer sur enregistrer les modifications pour sauvegarder le logo",
          "IMAGE_DELETE_SUCCESS": "Logo effacé",
          "IMAGE_DELETE_ERROR": "Impossible de supprimer le logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "La taille de l'image doit être inférieure à {size}Mo"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom du portail",
          "ERROR": "Le nom est requis"
        },
        "HEADER_TEXT": {
          "LABEL": "Texte de l'en-tête",
          "PLACEHOLDER": "Texte de l'en-tête du portail"
        },
        "PAGE_TITLE": {
          "LABEL": "Titre de la page",
          "PLACEHOLDER": "Titre de la page portail"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lien vers la page d'accueil",
          "PLACEHOLDER": "Lien vers la page d'accueil du portail",
          "ERROR": "URL invalide. Le lien de la page d'accueil doit commencer par « http:// » ou « https:// »."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug du portail"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget de chat en direct",
          "PLACEHOLDER": "Sélectionner un widget de chat en direct",
          "HELP_TEXT": "Sélectionnez un widget de chat en direct qui apparaîtra sur votre centre d'aide"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Accessible au public",
          "HELP_TEXT": "Rendre le portail accessible à toute personne disposant du lien.",
          "OPTIONS": {
            "PUBLIC": "Oui",
            "PRIVATE": "Non"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Cible du lien",
          "HELP_TEXT": "Choisissez si les liens dans les articles s'ouvrent dans la fenêtre actuelle ou dans une nouvelle.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Fenêtre actuelle",
            "NEW_WINDOW": "Nouvelle fenêtre"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Taille d'image par défaut",
          "HELP_TEXT": "Taille appliquée à chaque image que vous insérez dans un article. Choisissez Originale pour insérer les images à leur taille d'origine et choisir une taille pour chaque image individuellement."
        },
        "BRAND_COLOR": {
          "LABEL": "Couleur de la marque"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personnalisé",
          "PLACEHOLDER": "<!-- Collez ici votre extrait de code analytics ou de suivi -->",
          "HELP_TEXT": "Inséré au début de la balise <body> sur chaque page du centre d'aide. Utilisez-le pour Google Analytics, Google Tag Manager ou tout autre extrait de suivi. Le code est affiché exactement tel qu'il est saisi et n'est pas validé."
        },
        "SAVE_CHANGES": "Enregistrer les modifications"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domaine personnalisé",
          "LABEL": "Domaine personnalisé:",
          "DESCRIPTION": "Vous pouvez héberger votre portail sur un domaine personnalisé. Par exemple, si votre site web est yourdomain.com et que vous souhaitez que votre portail soit disponible à l'adresse docs.yourdomain.com, saisissez simplement cette adresse dans ce champ.",
          "PLACEHOLDER": "Portail de domaine personnalisé",
          "EDIT_BUTTON": "Modifier le domaine personnalisé",
          "ADD_BUTTON": "Ajouter un domaine personnalisé",
          "DIALOG": {
            "ADD_HEADER": "Ajouter un domaine personnalisé",
            "EDIT_HEADER": "Modifier le domaine personnalisé",
            "ADD_CONFIRM_BUTTON_LABEL": "Ajouter le domaine",
            "EDIT_CONFIRM_BUTTON_LABEL": "Mettre à jour le domaine",
            "LABEL": "Domaine personnalisé",
            "PLACEHOLDER": "Portail de domaine personnalisé",
            "ERROR": "Le domaine personnalisé est requis"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configuration DNS",
            "DESCRIPTION": "Connectez-vous au compte de votre fournisseur DNS et ajoutez l'enregistrement CNAME ci-dessous pour votre sous-domaine.",
            "HELP_TEXT": "Une fois cela fait, vous pouvez contacter notre support pour demander le certificat SSL généré automatiquement.",
            "CONFIRM_BUTTON_LABEL": "Compris !"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Supprimer {portalName}",
          "HEADER": "Supprimer le portail",
          "DESCRIPTION": "Supprimer définitivement ce portail. Cette action est irréversible",
          "DIALOG": {
            "HEADER": "Voulez-vous vraiment supprimer {portalName} ?",
            "DESCRIPTION": "Il s'agit d'une action définitive qui ne peut pas être annulée.",
            "CONFIRM_BUTTON_LABEL": "Supprimer"
          }
        },
        "EDIT_CONFIGURATION": "Modifier la configuration"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Le portail a été créé avec succès",
          "ERROR_MESSAGE": "Impossible de créer le portail"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Le portail a été mis à jour",
          "ERROR_MESSAGE": "Impossible de mettre à jour le portail"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Pièces jointes",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Ajouter un fichier",
      "DROP_HERE": "Glissez-déposez les fichiers ici",
      "COPY_LINK": "Copier le lien",
      "LINK_COPIED": "Lien copié dans le presse-papier",
      "COPY_FAILED": "Échec de la copie du lien",
      "DELETE": "Supprimer",
      "CANCEL": "Annuler",
      "QUEUED": "En attente",
      "UPLOADING": "Téléversement en cours",
      "UPLOAD_FAILED": "Échec du téléversement du fichier",
      "FILE_TOO_LARGE": "Le fichier dépasse la limite de taille de 40 Mo"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Dictionnaire de traduction",
        "DESCRIPTION": "Les termes définis ici sont ajoutés à l'invite de traduction IA afin qu'ils soient toujours traduits de la même façon. Le terme clé est rédigé en {locale}."
      },
      "NEW_TERM": "Nouveau terme",
      "EMPTY_STATE": {
        "TITLE": "Aucun terme de dictionnaire pour le moment",
        "SUBTITLE": "Ajoutez un terme et sa traduction pour chaque langue. Lorsqu'un article est traduit, ces termes sont appliqués afin que le vocabulaire de votre produit reste cohérent."
      },
      "LIST": {
        "TERM": "Terme",
        "TRANSLATIONS": "Traductions",
        "ACTIONS": "Actions"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Ajouter un terme",
          "EDIT": "Modifier le terme",
          "DESCRIPTION": "Le terme ci-dessous est appliqué lors de la traduction IA des articles de votre centre d'aide.",
          "PORTAL": "Portail",
          "PRIMARY_LANGUAGE": "Langue principale"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Terme ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Le terme est requis"
          },
          "DESCRIPTION": {
            "LABEL": "Contexte / notes (facultatif)",
            "PLACEHOLDER": "Quand et comment ce terme est utilisé, pour aider le traducteur à lever toute ambiguïté."
          },
          "TRANSLATIONS": "Traductions",
          "TRANSLATION_PLACEHOLDER": "Laisser vide pour laisser l'IA traduire librement",
          "AUTO_TRANSLATE": {
            "BUTTON": "Traduire tout automatiquement",
            "CONFIRM": "Traduire en {count} langues avec l'IA ?",
            "CONFIRM_BUTTON": "Traduire",
            "CANCEL": "Annuler",
            "SUCCESS": "Traductions générées — vérifiez et enregistrez",
            "ERROR": "Impossible de traduire automatiquement, veuillez réessayer"
          }
        },
        "BUTTONS": {
          "CREATE": "Ajouter un terme",
          "EDIT": "Enregistrer",
          "CANCEL": "Annuler"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Terme ajouté avec succès",
            "ERROR_MESSAGE": "Impossible d'ajouter le terme, veuillez réessayer"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Terme mis à jour avec succès",
            "ERROR_MESSAGE": "Impossible de mettre à jour le terme, veuillez réessayer"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Supprimer le terme",
          "DESCRIPTION": "Êtes-vous sûr de vouloir supprimer ce terme ? Il ne sera plus appliqué lors de la traduction.",
          "CONFIRM": "Supprimer"
        },
        "API": {
          "SUCCESS_MESSAGE": "Terme supprimé avec succès",
          "ERROR_MESSAGE": "Impossible de supprimer le terme, veuillez réessayer"
        }
      }
    }
  }
}
